export default {
    helpInfo: 'попробуйте очистить кэш браузера, нажав Ctrl+F5, затем выйдите и зайдите в CRM. ' +
            'Если не помогло, опишите проблему в электронном письме и адресуйте на _support_CRM@fix-price.ru',
    '403': 'Нет доступа',
    '404': 'Информация не найдена',
    '500': 'Внутренняя ошибка сервера',
    incorrectData: 'Некорректные данные',
    orderChangeStatus: 'Не удалось изменить статус заказа',
    unknownError: 'Неизвестная ошибка',
    notGetFile: 'Не удалось получить файл',
    'default': 'Неизвестная ошибка',
    failedToUpdateTheStamps: 'Не удалось обновить данные о марках в заказе!',
};